import { ReactElement, useEffect, useState } from 'react';
import { Header } from '@designSystem/typings';
import Lang from '@lang/en';
import Button from '@root/src/app/designSystem/buttons';
import {
  HeaderRow,
  ModalButtonsRow,
  ModalContainer,
  ModalRow,
  ModalSubHeaderRow,
  ThinParagraph,
} from './styles';
import { CloseMark } from '@root/src/assets/images';
import useRefreshOTP from './useRefreshOTP';
import Input from '../../designSystem/input/input';

interface PropsI {
  handleClose: () => void;
  setShouldReload?: (shouldReload: boolean) => void;
}

const RefreshOTPModal = ({
  handleClose,
  setShouldReload,
}: PropsI): ReactElement => {
  const [otpValue, setOTPValue] = useState('');
  const { refreshOTP, error, isRefreshed } = useRefreshOTP();

  const handleRefreshOTP = (otp: string) => {
    refreshOTP(otp);
  };

  useEffect(() => {
    if (isRefreshed) {
      setShouldReload && setShouldReload(true);
      handleClose();
    }
  }, [handleClose, isRefreshed, setShouldReload]);

  return (
    <ModalContainer>
      <HeaderRow>
        <Header data-testid="healthcheck-order-edit-modal-header">
          {Lang.healthCheckRefreshOTPModalLabel}
        </Header>
        <CloseMark onClick={handleClose} />
      </HeaderRow>
      <ModalSubHeaderRow>
        <ThinParagraph>
          {Lang.healthCheckRefreshOTPModalDescription}
        </ThinParagraph>
      </ModalSubHeaderRow>
      <ModalRow>
        <Input
          placeholder={Lang.healthCheckRefreshOTPModalInputPlaceholder}
          value={otpValue}
          onChange={(event) => {
            setOTPValue(event.target.value);
          }}
          errorMessage={error as string}
        />
      </ModalRow>
      <ModalButtonsRow>
        <Button
          type="tertiary"
          data-testid="healthcheck-modal-order-delete-cannel-button"
          label={Lang.cancelText}
          onClick={handleClose}
        />
        <Button
          type="primary"
          data-testid="healthcheck-modal-order-delete-remove-button"
          label={Lang.saveText}
          onClick={() => handleRefreshOTP(otpValue)}
        />
      </ModalButtonsRow>
    </ModalContainer>
  );
};

export default RefreshOTPModal;
